import { SearchParam } from '../../../../hooks'
import { addJstDate } from '../../../../utils'

/**
 * Builds the search-param update for the schedule month selector.
 *
 * Updating only `checkInDate` left a stale `checkOutDate` behind, which could
 * end up before the new check-in (an inverted date range). We always move the
 * check-out to the day after the new check-in (the app-wide 1-night default) so
 * the range stays valid. (#1775)
 */
export const getMonthChangeSearchParams = (
  checkInDate: string
): Pick<SearchParam, 'checkInDate' | 'checkOutDate'> => ({
  checkInDate,
  checkOutDate: addJstDate(checkInDate, 1),
})
